import { IAppointmentDetails, IAppointmentItemResponse }
  from "../../../services/appointment-list/appointment-list.interface";
import { useDispatch, useSelector } from "react-redux";

import { AppointmentFormSchemaType } from "../../../state/createAppointmentData/createAppointment.reducer";
import { IBookedAppointmentsState } from "../../../state/bookedAppointments";
import { ICreateAppointmentState } from "../../../state/createAppointmentData";
import { IPetItemResponse } from "../../../services/pet-list/pet-list.interface";
import { IRootState } from "../../../state";
import { appointmentActions } from "../../../state/bookedAppointments";
import { createAppointmentActions } from "../../../state/createAppointmentData";
import { IAppointmentCreateResponse, IPetDataInputForm }
  from "../../../services/create-appointment-v2/create-appointment-v2.interface";

export const useAppointmentStore = () => {
  const dispatch = useDispatch();
  const {
    selectedVisit,
    appointmentDetails,
    appointmentsResponse,
    appointmentsRescheduleResponse,
    pastAppointments,
    groupedAppointments,
  } = useSelector((state: IRootState) => state.appointments as IBookedAppointmentsState);
  const {
    reasonForVisit,
    selectedPets,
    appointmentForm,
    promoCode,
    currentStep,
  } = useSelector((state: IRootState) => state.createAppointment as ICreateAppointmentState);

  const setSelectedVisit = (visit: IAppointmentItemResponse | IAppointmentDetails | null) => {
    dispatch(appointmentActions.setVisitSelected(visit));
  };

  const setReasonForVisit = (reasons: {[key: string]: IPetDataInputForm}) => {
    dispatch(createAppointmentActions.setReasonForVisit(reasons));
  };

  const setSelectedPets = (pets: IPetItemResponse[]) => {
    dispatch(createAppointmentActions.setSelectedPets(pets));
  };

  const setAppointmentsForm = (data: AppointmentFormSchemaType|null ) => {
    dispatch(createAppointmentActions.setAppointmentsForm(data));
  };

  const setAppointmentDetails = (data: IAppointmentDetails | null) => {
    dispatch(appointmentActions.setAppointmentDetails(data));
  };

  const setAppointmentResponse = (data: IAppointmentCreateResponse | null) => {
    dispatch(appointmentActions.setAppointmentsResponse(data));
  };

  const setRescheduleAppointmentsResponse = (data: IAppointmentCreateResponse | null) => {
    dispatch(appointmentActions.setRescheduleAppointmentsResponse(data));
  };

  const setPromoCodeData = (data: string[]) => {
    dispatch(createAppointmentActions.setPromoCode(data));
  };

  const setCurrentStep = (step: number) => {
    dispatch(createAppointmentActions.setCurrentStep(step));
  };

  const resetCurrentBookingStep = () => {
    dispatch(createAppointmentActions.setCurrentStep(0));
  };

  const setGroupedAppointments = (data: IAppointmentDetails[] | null) => {
    dispatch(appointmentActions.setGroupedAppointments(data));
  };

  return {
    setSelectedVisit,
    setSelectedPets,
    setAppointmentsForm,
    selectedVisit,
    setReasonForVisit,
    reasonForVisit,
    selectedPets,
    appointmentForm,
    appointmentsResponse,
    appointmentsRescheduleResponse,
    appointmentDetails,
    setAppointmentDetails,
    setAppointmentResponse,
    setRescheduleAppointmentsResponse,
    setPromoCodeData,
    promoCode,
    pastAppointments,
    setCurrentStep,
    currentStep,
    resetCurrentBookingStep,
    groupedAppointments,
    setGroupedAppointments,
  };
};
